const state = {
  currentOrganization: {}
}

const mutations = {
  setCurrentOrganization: (state, payload) => {
    if (payload.organization) {
      state.currentOrganization = Object.assign({}, state.currentOrganization, payload.organization)
    }
  }
}

const actions = {
  loadCurrentOrganization: ({commit, rootState}, payload) => {
    return rootState.apiInstance.get(`/organizations/${payload.identifier}`)
      .then(response => {
        commit('setCurrentOrganization', {organization: response.data.data})
      })
  },
  createOrganization: ({rootState}, payload) => {
    return rootState.apiInstance.post('/organizations', payload)
      .then(response => response.data.data)
  },
  updateOrganization: ({commit, rootState}, payload) => {
    return rootState.apiInstance.put(`/organizations/${payload.id}`, payload)
      .then(response => {
        commit('setCurrentOrganization', {organization: response.data.data})
        return response.data.data
      })
  },
  linkShowSeriesToOrganization: ({rootState}, payload) => {
    return rootState.apiInstance.put(`/data/showSeries/${payload.show_series_id}`, {organization_id: payload.organization_id})
  },
  setSeriesEmbedOnOrganization: ({rootState}, payload) => {
    const updatedSettings = Object.assign({}, payload.series_settings, {embed_on_organization: payload.embed_on_organization})
    return rootState.apiInstance.put(`/data/showSeries/${payload.show_series_id}`, {series_settings: updatedSettings})
  }
}

export default {
  namespaced: false,
  state,
  actions,
  mutations
}
